'use client';
import type { PropsWithChildren } from 'react';
import { useStickyBox } from 'react-sticky-box';
import { useClientOnlyMediaQuery } from '~/common/hooks/use-client-only-media-query';
import { Media } from '~/utils/styles/enums';
import { Box } from '@styled-system/jsx';

type Props = PropsWithChildren<{}>;

export const StickyAside = ({ children }: Props) => {
  const screenLarge = useClientOnlyMediaQuery(Media.LARGE);
  const stickyRef = useStickyBox();

  return (
    <Box
      ref={screenLarge ? stickyRef : undefined}
      alignSelf="start"
      width="100%"
      lg={{
        minW: '300px',
        maxW: '370px',
      }}
      gap="0"
    >
      {children}
    </Box>
  );
};
